<div class="filter-dialog">
    <div class="filter-dialog-body">
        <div class="filter-dialog-header">
            <h3 class="title-filter">{{ 'activity.filter_by' | translate }}</h3>
            <button class="close-btn" (click)="cancel()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-label>{{ 'fee.group' | translate }}</mat-label>
                <mat-select [(value)]="selectedGroupId" panelClass="filter-select-panel" (selectionChange)="onGroupChange($event)">
                    <mat-option [value]="null">{{ 'fee.all' | translate }}</mat-option>
                    <mat-option *ngFor="let group of data.groups" [value]="group.id">{{ group.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-label>{{ 'fee.subgroup' | translate }}</mat-label>
                <mat-select [(value)]="selectedSubgroupId" panelClass="filter-select-panel">
                    <mat-option [value]="null">{{ 'fee.all' | translate }}</mat-option>
                    <mat-option *ngFor="let subgroup of availableSubgroups" [value]="subgroup.id">{{ subgroup.name }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-label>{{ 'fee.period' | translate }}</mat-label>
                <mat-date-range-input [rangePicker]="periodPicker">
                    <input matStartDate [(ngModel)]="periodFrom" [ngModelOptions]="{standalone: true}" [placeholder]="'activity.from' | translate" (focus)="periodPicker.open()">
                    <input matEndDate [(ngModel)]="periodTo" [ngModelOptions]="{standalone: true}" [placeholder]="'activity.to' | translate" (focus)="periodPicker.open()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="periodPicker"></mat-datepicker-toggle>
                <mat-date-range-picker #periodPicker>
                    <mat-date-range-picker-actions>
                        <button mat-button class="button-size-16" matDateRangePickerCancel>{{ 'activity.reset' | translate }}</button>
                        <button mat-button class="button-size-16" matDateRangePickerApply>{{ 'activity.ok' | translate }}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </div>

        <div class="filter-field">
            <mat-form-field appearance="outline" class="filter-select-field">
                <mat-select [(value)]="selectedStatus" panelClass="filter-select-panel">
                    <mat-option value="ALL">{{ 'fee.all' | translate }}</mat-option>
                    <mat-option value="PAID">{{ 'fee.status.paid' | translate }}</mat-option>
                    <mat-option value="PENDING">{{ 'fee.status.pending' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="filter-dialog-actions">
        <button class="reset-btn" (click)="resetFilters()">{{ 'activity.reset' | translate }}</button>
        <button class="apply-btn" (click)="applyFilter()">{{ 'activity.filter' | translate }}</button>
    </div>
</div>
